import styled, { css } from 'styled-components'

import { outline } from './Outline'

export const button = css`
  all: unset;

  ${outline}
`

export const ClearButton = styled.button`
  ${button}
`
